import { render } from "./faperta.vue?vue&type=template&id=16da0097&scoped=true"
import script from "./faperta.vue?vue&type=script&lang=js"
export * from "./faperta.vue?vue&type=script&lang=js"

import "./faperta.vue?vue&type=style&index=0&id=16da0097&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16da0097"]])

export default __exports__